export default __webpack_public_path__ + "390544ac142b36c490f066b56869c129.png";